import React from "react";
import ReactDOM from "react-dom";
import { Catalog, pageLoader } from "catalog";

const pages = [
  {
    path: "/",
    title: "Our Design System",
    content: pageLoader(() => import("./pages/welcome.md"))
  },
  {
    path: "/buttons",
    title: "Buttons",
    content: pageLoader(() => import("./pages/buttons.md"))
  },
  {
    path: "/button-group",
    title: "Button Groups",
    content: pageLoader(() => import("./pages/button-group.md"))
  },
  {
    path: "/card",
    title: "Cards",
    content: pageLoader(() => import("./pages/cards.md"))
  },
  {
    path: "/checkbox",
    title: "Checkbox",
    content: pageLoader(() => import("./pages/checkbox.md"))
  },
  {
    path: "/containers",
    title: "Container",
    content: pageLoader(() => import("./pages/containers.md"))
  },
  {
    path: "/data",
    title: "Data",
    content: pageLoader(() => import("./pages/data.md"))
  },
  {
    path: "/data-set",
    title: "Data Set",
    content: pageLoader(() => import("./pages/data-set.md"))
  },
  {
    path: "/desktop-navigation",
    title: "Desktop Navigation",
    content: pageLoader(() => import("./pages/desktop-navigation.md"))
  },
  {
    path: "/file-input",
    title: "File Input",
    content: pageLoader(() => import("./pages/file-input.md"))
  },
  {
    path: "/icons",
    title: "Icons",
    content: pageLoader(() => import("./pages/icons.md"))
  },
  {
    path: "/input-group",
    title: "Input Group",
    content: pageLoader(() => import("./pages/form-group.md"))
  },
  {
    path: "/input",
    title: "Input Field",
    content: pageLoader(() => import("./pages/input.md"))
  },
  {
    path: "/loading",
    title: "Loading States",
    content: pageLoader(() => import("./pages/loading-states.md"))
  },
  {
    path: "/mobile-tabs",
    title: "Mobile Tabs",
    content: pageLoader(() => import("./pages/mobile-navigation.md"))
  },
  {
    path: "/modal",
    title: "Modal",
    content: pageLoader(() => import("./pages/modal.md"))
  },
  {
    path: "/banner",
    title: "Notice Banner",
    content: pageLoader(() => import("./pages/notice-banner.md"))
  },
  {
    path: "/progress-bar",
    title: "Progress / Percentage Bar",
    content: pageLoader(() => import("./pages/progress-bar.md"))
  },
  {
    path: "/radio",
    title: "Radio",
    content: pageLoader(() => import("./pages/radio.md"))
  },
  {
    path: "/select",
    title: "Select",
    content: pageLoader(() => import("./pages/select.md"))
  },
  {
    path: "/status",
    title: "Status / Tags",
    content: pageLoader(() => import("./pages/status.md"))
  },
  {
    path: "/step-sequence",
    title: "Step Sequence",
    content: pageLoader(() => import("./pages/step-sequence.md"))
  },
  {
    path: "/textarea",
    title: "TextArea",
    content: pageLoader(() => import("./pages/textarea.md"))
  },
  {
    path: "/typography",
    title: "Text / Typography",
    content: pageLoader(() => import("./pages/typography.md"))
  },
  {
    path: "/utilities",
    title: "Utility Classes",
    content: pageLoader(() => import("./pages/utilities.md"))
  }

];


ReactDOM.render(
  <Catalog 
    title="FCDS | v1.5"
    pages={pages}
    //logoSrc="/fcds_logo.svg"
    styles={["/style.css", "/main-dist.css"]}
    responsiveSizes={[
      {name: 'mobile', width: 320, height: 480},
      {name: 'tablet', width: 800, height: 600},
      {name: 'desktop', width: 1024, height: 768}
    ]}
    theme={
      {
        pageHeadingHeight: 145,
        textColor: "#231F20",
        background: "#FFFFFF",
        brandColor: "#003A70",
        linkColor: "#474FD9",

        //Page Headings
        pageHeading: { Background: "#003A70", TextColor: "#fff" },
        pageHeadingBackground: "#003A70",
        pageHeadingTextColor: "#fff",
        
        fontFamily: "Lota Grotesque Regular",
        fontHeading: "Lota Grotesque Semibold",
        fontMono: "IBM Plex Mono, monospace",
        sidebarColorHeading: "#003A70",
        sidebarColorTextActive: "#003A70",
        sidebarColorActive: "#003A70",
        sidebarColorText: "#484848",
      }
    }
  />,
  document.getElementById("catalog")
)




// WEBPACK FOOTER //
// ./catalog/index.js